import { Button, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IMobileAppBannerProps {
  url: string;
  onClick: () => void;
}

export function MobileAppBanner({ url, onClick }: IMobileAppBannerProps) {
  return (
    <div className={styles['container']} data-testid="MobileAppBanner">
      <a href={url} target="_blank" rel="noreferrer" onClick={onClick} className={styles['wrapper']}>
        <div className={styles['title']}>
          <UIHeading4>В приложении уже есть отзывы </UIHeading4>
        </div>
        <Button size="M" theme="fill_white_primary">
          Установить
        </Button>
      </a>
    </div>
  );
}
